// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__365Ru","imageUploader":"EGiftCard_imageUploader__3rpEL"};